import React, { useState } from "react";
import "./ViewCareer.scss";
import usStates from "united-states";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { CInputGroup } from "@coreui/react";
import JobOpeningService from "Pages/AdministratorDashboard/APIServices/JopOpeningService";
import ValidationError from "./ValidationError";
import { Button } from "antd";
import {
  WorkAuthorizationStatusEnum,
  WorkAuthorizationApplyOptions,
} from "Constants/Enums/WorkAuthorizationStatusEnum";

function InputFields() {
  const {
    formData,
    setFormData,
    options,
    handleSubmit,
    isSubmitted,
    handleUploadresumeChange,
    handleUploadDocChange,
    handleChange,
    formDataError,
    handleCancelClick,
    isLoading,
  } = JobOpeningService();

  // Q1 (are you authorized?) is a UI gate only; it is not sent to the API.
  const [authorizedToWork, setAuthorizedToWork] = useState("");

  return (
    <form onSubmit={handleSubmit} encType="multipart/formData">
      <ToastContainer />

      <div className="row">
        <div className="col-md-5 mb-3">
          <div className="mb-3">
            <label
              htmlFor="exampleInputEmail1"
              className="form-label"
              style={{ fontSize: "medium" }}
            >
              Gender *
            </label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className={`form-select form-select-sm ${
                formDataError.genderError ? "is-invalid" : ""
              }`}
              aria-label="Default select example"
            >
              <option value=""> Please Select </option>
              <option value="Male"> Male </option>
              <option value="Female"> Female </option>
              <option value="UnSpecified"> UnSpecified </option>
              <option value="Do not wish to disclosed"> Do not wish to disclosed </option>
            </select>
            <ValidationError errorMessage={formDataError.genderError} />
          </div>
        </div>
        <div className="col-md-5 mb-3">
          <div className="mb-3">
            <label
              htmlFor="exampleInputEmail1"
              className="form-label"
              style={{ fontSize: "medium" }}
            >
              Marital Status *
            </label>
            <select
              name="maritalStatus"
              value={formData.maritalStatus}
              onChange={handleChange}
              className={`form-select form-select-sm ${
                formDataError.maritalStatusError ? "is-invalid" : ""
              }`}
              aria-label="Default select example"
            >
              <option value=""> Please Select </option>
              <option value="Single"> Single </option>
              <option value="Married"> Married </option>
              <option value="Divorced"> Divorced </option>
              <option value="Widow"> Widow </option>
            </select>
            <ValidationError errorMessage={formDataError.maritalStatusError} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-5 mb-3">
          <div className="mb-3">
            <label htmlFor="exampleInput" className="form-label" style={{ fontSize: "medium" }}>
              Street Address *
            </label>
            <input
              type="text"
              name="streetAddress"
              value={formData.streetAddress}
              onChange={handleChange}
              placeholder="Enter street address here"
              className={`form-control ${formDataError.streetAddressError ? "is-invalid" : ""}`}
            />
            <ValidationError errorMessage={formDataError.streetAddressError} />
          </div>
        </div>
        <div className="col-md-5 mb-3">
          <div className="mb-3">
            <label htmlFor="exampleInput" className="form-label" style={{ fontSize: "medium" }}>
              City *
            </label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="Enter City here"
              className={`form-control ${formDataError.cityError ? "is-invalid" : ""}`}
            />
            <ValidationError errorMessage={formDataError.cityError} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-5 mb-3">
          <div className="mb-3">
            <label htmlFor="exampleInput" className="form-label" style={{ fontSize: "medium" }}>
              State *
            </label>
            <select
              name="state"
              value={formData.state}
              onChange={handleChange}
              aria-label=".form-select-sm example"
              className={`form-select ${formDataError.stateError ? "is-invalid" : ""}`}
            >
              <option value="" disabled>
                Please select States
              </option>
              {usStates.map((state) => (
                <option key={state.abbreviation} value={state.abbreviation}>
                  {state.name}
                </option>
              ))}
            </select>
            <ValidationError errorMessage={formDataError.stateError} />
          </div>
        </div>
        <div className="col-md-5 mb-3">
          <div className="mb-3">
            <label htmlFor="exampleInput" className="form-label" style={{ fontSize: "medium" }}>
              Postal Code *
            </label>
            <input
              type="number"
              name="postalCode"
              value={formData.postalCode}
              onChange={handleChange}
              placeholder="Enter postal code here"
              className={`form-control ${formDataError.postalCodeError ? "is-invalid" : ""}`}
            />
            <ValidationError errorMessage={formDataError.postalCodeError} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-5 mb-3">
          <div className="mb-3">
            <label htmlFor="exampleInput" className="form-label" style={{ fontSize: "medium" }}>
              Country *
            </label>
            <select
              defaultValue="US"
              name="country"
              value={formData.country}
              onChange={handleChange}
              aria-label=".form-select-sm example"
              className={`form-control ${formDataError.countryError ? "is-invalid" : ""}`}
            >
              <option value="">Please select</option>
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <ValidationError errorMessage={formDataError.countryError} />
          </div>
        </div>
        <div className="col-md-5 mb-3">
          <div className="mb-3">
            <label htmlFor="exampleInput" className="form-label" style={{ fontSize: "medium" }}>
              Cover Letter *
            </label>
            <input
              type="file"
              accept=".pdf,.PDF,.docx,.DOCX,.doc,.DOC"
              onChange={(e) => {
                handleUploadDocChange(e);
              }}
              className={`form-control ${formDataError.coverLetterError ? "is-invalid" : ""}`}
            />
            <ValidationError errorMessage={formDataError.coverLetterError} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-5 mb-3">
          <div className="mb-3">
            <label htmlFor="exampleInput" className="form-label" style={{ fontSize: "medium" }}>
              Resume *
            </label>
            <input
              type="file"
              // value={formData.resume}
              // onChange={handleFileChange}
              accept=".pdf,.PDF,.docx,.DOCX,.doc,.DOC"
              onChange={(e) => {
                handleUploadresumeChange(e);
              }}
              className={`form-control ${formDataError.resumeError ? "is-invalid" : ""}`}
            />
            <ValidationError errorMessage={formDataError.resumeError} />
          </div>
        </div>
        <div className="col-md-5 mb-3">
          <div className="mb-3">
            <label htmlFor="exampleInput" className="form-label" style={{ fontSize: "medium" }}>
              Date Available *
            </label>
            <input
              type="date"
              name="dateAvailable"
              value={formData.dateAvailable}
              onChange={handleChange}
              className={`form-control ${formDataError.dateAvailableError ? "is-invalid" : ""}`}
            />
            <ValidationError errorMessage={formDataError.dateAvailableError} />
          </div>
        </div>
      </div>
      <div className="row">
        {/* Q1: work authorization gate (UI only, not sent to API) */}
        <div className="col-md-5 mb-3">
          <div className="mb-3">
            <label className="form-label" style={{ fontSize: "medium" }}>
              Are you currently legally authorized to work in the US? *
            </label>
            <select
              aria-label="Work authorization"
              value={authorizedToWork}
              onChange={(e) => {
                setAuthorizedToWork(e.target.value);
                // Reset the dependent answers whenever Q1 changes.
                setFormData({
                  ...formData,
                  workAuthorizationStatus: "",
                  sponsorshipNeeded: "",
                });
              }}
              className="form-select"
            >
              <option value=""> Please Select </option>
              <option value="yes"> Yes </option>
              <option value="no"> No </option>
            </select>
            {authorizedToWork === "no" && (
              <div className="text-danger" style={{ marginTop: 6, fontSize: "0.9rem" }}>
                You must be currently authorized to work in the US to apply for this position.
              </div>
            )}
          </div>
        </div>

        {/* Q2: work authorization status (only when authorized) */}
        {authorizedToWork === "yes" && (
          <div className="col-md-5 mb-3">
            <div className="mb-3">
              <label className="form-label" style={{ fontSize: "medium" }}>
                What is your current US work authorization status? *
              </label>
              <select
                aria-label="Work authorization status"
                name="workAuthorizationStatus"
                value={formData.workAuthorizationStatus}
                onChange={(e) => {
                  const v = e.target.value;
                  const isCitizen = Number(v) === WorkAuthorizationStatusEnum.USCitizen;
                  setFormData({
                    ...formData,
                    workAuthorizationStatus: v,
                    // US citizens never need sponsorship.
                    sponsorshipNeeded: isCitizen ? false : "",
                  });
                }}
                className={`form-select ${
                  formDataError.workAuthorizationStatusError ? "is-invalid" : ""
                }`}
              >
                <option value=""> Please Select </option>
                {WorkAuthorizationApplyOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
              <ValidationError errorMessage={formDataError.workAuthorizationStatusError} />
            </div>
          </div>
        )}

        {/* Q3: sponsorship (only for non-citizens) */}
        {authorizedToWork === "yes" &&
          formData.workAuthorizationStatus !== "" &&
          Number(formData.workAuthorizationStatus) !== WorkAuthorizationStatusEnum.USCitizen && (
            <div className="col-md-5 mb-3">
              <div className="mb-3">
                <label className="form-label" style={{ fontSize: "medium" }}>
                  Will you now or in the future require sponsorship to work, extend, or transfer
                  your current visa? *
                </label>
                <select
                  aria-label="Sponsorship needed"
                  name="sponsorshipNeeded"
                  value={String(formData.sponsorshipNeeded)}
                  onChange={handleChange}
                  className={`form-select ${
                    formDataError.sponsorshipNeededError ? "is-invalid" : ""
                  }`}
                >
                  <option value=""> Please Select </option>
                  <option value="true"> Yes </option>
                  <option value="false"> No </option>
                </select>
                <ValidationError errorMessage={formDataError.sponsorshipNeededError} />
              </div>
            </div>
          )}
      </div>
      <div className="row">
        <div className="col-md-10">
          <Button
            style={{ float: "inline-end" }}
            className="btn-primary"
            disabled={isSubmitted || isLoading}
            htmlType="submit"
          >
            {isSubmitted ? "Applied" : isLoading ? "Please wait..." : "Submit"}
          </Button>
          <Button
            style={{ float: "inline-end", marginRight: "10px" }}
            className="btn-cancel"
            type="default"
            onClick={handleCancelClick}
          >
            Cancel
          </Button>
        </div>
      </div>
    </form>
  );
}

export default InputFields;
